import { Dropdown } from 'antd'
import DownArrow from 'components/icons/DownArrow'
import VerticalThreeDots from 'components/icons/VerticalThreeDots'
import React, { useState } from 'react'

import {
  ActionMenu,
  ButtonText,
  Main,
  SmallButtons,
  StyledDropDownButton,
} from 'components/ActionStyles/ActionStyles'
import { useNavigate } from 'react-router'

const ActionsRole = ({
  needViewButton = true,
  setJobId,
  data,
  getJobDetails,
  onAcceptOrRejectClick,
  corporateAboutUs,
  cruds,
  onAcceptOrRejectRole,
  setEventId,
}) => {
  const navigate = useNavigate()
  const [viewDrawer, setViewDrawer] = useState(false)

  const handleMenuClick = id => {
    getJobDetails({
      id: data?.jobRoles?.id,
      corporateId: data.jobRoles.corporate.id,
    })
    corporateAboutUs(data.jobRoles.corporate.id)
    navigate(`details`)
  }
  const viewHandler = () => {
    getJobDetails({
      id: data?.jobRoles?.id,
      corporateId: data.jobRoles.corporate.id,
    })
    corporateAboutUs(data.jobRoles.corporate.id)
    navigate(`details`)
  }
  const onItemClick = item => {
    onAcceptOrRejectClick(data)
  }
  const menu = (
    <ActionMenu
      width={'165px'}
      items={[
        {
          key: 'edit',
          label: 'Accept/Reject',
          onClick: item => {
            setEventId(onAcceptOrRejectRole?.id)
            onItemClick(item)
          },
          disabled: data?.status == 1 || !onAcceptOrRejectRole,
        },
      ]}
    />
  )
  return (
    <>
      {needViewButton && cruds?.includes('VIEW') ? (
        <Main id="FilterDropdown">
          <StyledDropDownButton
            overlay={menu}
            shape="round"
            onClick={() => handleMenuClick()}
            trigger={['click']}
            icon={<DownArrow />}
            getPopupContainer={() => document.getElementById('FilterDropdown')}
          >
            <ButtonText onClick={viewHandler}>View</ButtonText>
          </StyledDropDownButton>
        </Main>
      ) : (
        cruds?.includes('ACCEPT/REJECT') && (
          <Dropdown
            overlay={menu}
            trigger={['click']}
            id="FilterDropdown"
            getPopupContainer={() => document.getElementById('FilterDropdown')}
          >
            <a onClick={e => e.preventDefault()}>
              <SmallButtons height={'38px'} icon={<VerticalThreeDots />} />
            </a>
          </Dropdown>
        )
      )}
    </>
  )
}

export default ActionsRole